var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 8L4.22347 13.7402C3.92551 14.0284 3.92551 14.4957 4.22348 14.7839C4.52144 15.0721 5.00453 15.072 5.30249 14.7838L11.7765 8.52183C12.0745 8.23363 12.0745 7.76637 11.7765 7.47817L5.30249 1.21615C5.00453 0.927951 4.52144 0.927949 4.22348 1.21615C3.92551 1.50435 3.92551 1.97161 4.22347 2.25981L10.158 8Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.9d2533b8.svg";
export { ForwardRef as ReactComponent };var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrows({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 8L4.22347 13.7402C3.92551 14.0284 3.92551 14.4957 4.22348 14.7839C4.52144 15.0721 5.00453 15.072 5.30249 14.7838L11.7765 8.52183C12.0745 8.23363 12.0745 7.76637 11.7765 7.47817L5.30249 1.21615C5.00453 0.927951 4.52144 0.927949 4.22348 1.21615C3.92551 1.50435 3.92551 1.97161 4.22347 2.25981L10.158 8Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/Arrows.9d2533b8.svg";
export { ForwardRef as ReactComponent };